module.exports = __webpack_public_path__ + "static/img/17.67a2119c.jpg";